<template>
  <g v-if="showVerticalLines">
    <line
      v-for="(vline, index) in vLines"
      :key="index"
      :x1="vline"
      y1="0"
      :x2="vline"
      y2="100%"
      stroke="lightgray"
      stroke-width="1"
      stroke-dasharray="3,3"
    />
  </g>
</template>

<script>
import DesignerMixin from "../../../DesignerMixin";
import { SPACE_BETWEEN_VLINES } from "./ElementUtils";

export default {
  mixins: [DesignerMixin],
  props: ["x"],
  computed: {
    vLines() {
      const vLines = [];
      for (let line = SPACE_BETWEEN_VLINES; line <= this.processFlowWidth; line += SPACE_BETWEEN_VLINES) {
        vLines.push(line);
      }

      return vLines;
    },
    showVerticalLines() {
      return this.$store.state.customFlow.showVerticalLines;
    },
  },
};
</script>
